export const GET_PRODUCTS = 'getProducts';
export const GET_PRODUCTS_V2 = 'getProductsV2';
export const GET_PRODUCTS_V3 = 'getProductsV3';
export const GET_REVIEW_PRODUCT = 'getReviewProduct';
export const GET_SELECTED_FILTERS = 'get.selected.filters';
export const GET_SORTBY_VALUE = 'get.sortby.value';
export const GET_SKUS = 'getSkus';

export type ServiceProdcatQueries = {
    [GET_PRODUCTS]: {};
    [GET_PRODUCTS_V2]: {};
    [GET_PRODUCTS_V3]: {};
    [GET_REVIEW_PRODUCT]: {};
    [GET_SELECTED_FILTERS]: {};
    [GET_SORTBY_VALUE]: {};
    [GET_SKUS]: {};
};

export type ServiceProdcatQueriesResponseType = {
    [GET_PRODUCTS]: {};
    [GET_PRODUCTS_V2]: {};
    [GET_PRODUCTS_V3]: {};
    [GET_REVIEW_PRODUCT]: {};
    [GET_SELECTED_FILTERS]: {};
    [GET_SORTBY_VALUE]: {};
    [GET_SKUS]: {};
};
